import React, { useState } from "react";
import "./index.less";
import { Button, Tabs, TabsProps } from "antd";
import { ChatSearchSVG } from "../../SvgIconCom";
// import { useParams } from "react-router-dom";
// import { throttle } from "lodash-es";

export interface ContentTabsTopProps {
    tabItems: TabsProps["items"];
    showSearch?: boolean;
    showSearchInput?: boolean;
    handleSearchInput?: (show: boolean) => void;
    handleSearch?: (keyWord: string) => void;
    handleChangeTab: (key: string) => void;
}
export const ContentTabsTop: React.FC<ContentTabsTopProps> = ({
    tabItems,
    showSearch = false,
    handleChangeTab,
    showSearchInput,
    handleSearchInput,
    // handleSearch,
}) => {
    // const params = useParams();
    const [activeKey, setActiveKey] = useState<string>(tabItems?.[0].key ?? "");
    // const [isSearching, setIsSearching] = useState<boolean>(false);
    // const [searchKey, setSearchKey] = useState<string>("");
    // useEffect(() => {
    //     setIsSearching(false);
    // }, [params]);
    const changeTabs = (key: string): void => {
        setActiveKey(key);
        // TODO: 切换tab的event
        handleChangeTab && handleChangeTab(key);
    };

    // const throttleSearch = useCallback(
    //     throttle((key: string) => handleSearch?.(key), 500),
    //     [handleSearch],
    // );

    return (
        <div className="content-top">
            {/* {!isSearching && ( */}
            <Tabs
                activeKey={activeKey}
                items={tabItems}
                popupClassName="content-tabs"
                onChange={changeTabs}
            ></Tabs>
            {/* )} */}
            {/* {showSearch && isSearching ? (
                <div className="search-container expanded">
                    <Input
                        prefix={
                            <Button
                                className="search-button"
                                icon={<ChatSearchSVG />}
                                type="text"
                                onClick={() => setIsSearching(true)}
                            ></Button>
                        }
                        value={searchKey}
                        onChange={e => {
                            const val = e.target.value;
                            setSearchKey(val);
                            throttleSearch(val);
                        }}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                handleSearch?.(searchKey);
                            }
                        }}
                    />
                </div>
            ) : ( */}
            {showSearch && !showSearchInput && (
                <div className="search-container">
                    <Button
                        className="search-button"
                        icon={<ChatSearchSVG />}
                        type="text"
                        onClick={() => handleSearchInput && handleSearchInput(true)}
                    ></Button>
                </div>
            )}
            {/* )} */}
        </div>
    );
};
